<template>
  <div class="coderpix_tm_section animated" id="home">
    <div class="section_inner">
      <div class="coderpix_tm_home">
        <h3 class="name" v-html="heroTitle.replace(' ', ' <span class=\'coloring\'>') + '</span>'"></h3>
        <h3 class="job">
          <AnimationText />
        </h3>
        <div class="coderpix_tm_button transition_link">
          <a href="#contact" @click="navFuntions.activeSection('contact')"
            >Bana Ulaşın</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";
import AnimationText from "./AnimationText.vue";
import sanityClient from "../sanity";

export default {
  name: `HomeComponent`,
  data() {
    return {
      navFuntions,
      heroTitle: "Okan Şahin",
    };
  },
  components: { AnimationText },
  async mounted() {
    try {
      const query = `*[_type == "siteSettings"][0]{heroTitle}`;
      const settings = await sanityClient.fetch(query);
      if (settings && settings.heroTitle) {
        this.heroTitle = settings.heroTitle;
      }
    } catch (error) {
      console.log(error);
    }
  }
};
</script>


